import React from 'react';

const CopyIcon = ({ fill, width, height, opacity = 1, ...rest }) => (
    <svg className="icon copy-icon" width={width} height={height} viewBox="0 0 16 16" {...rest}>
        <path
            fill={fill}
            fillRule="nonzero"
            d="M4.544 6.481a3.503 3.503 0 0 1 4.954 0 .5.5 0 1 1-.708.708 2.502 2.502 0 0 0-3.538 0l-3.54 3.538a2.502 2.502 0 0 0 3.54 3.54l2.495-2.496a.5.5 0 1 1 .707.708L5.96 14.974a3.503 3.503 0 1 1-4.954-4.954zm5.455-5.455a3.503 3.503 0 1 1 4.954 4.954L11.414 9.52a3.503 3.503 0 0 1-4.954 0 .5.5 0 1 1 .708-.708 2.502 2.502 0 0 0 3.539 0l3.538-3.538a2.502 2.502 0 0 0-3.538-3.54L8.21 4.23a.5.5 0 1 1-.707-.708z"
        />
    </svg>
);

export default CopyIcon;
